import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import useScrollReveal from '../hooks/useScrollReveal';

const Footer = ({ showToast }) => {
  useScrollReveal();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());

  const handleSubmit = (e) => {
    e.preventDefault();
    showToast('Thank you for subscribing!', 'success');
    setEmail('');
  };

  // Update clock every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, '0');
    return { time: `${hours}:${minutes}:${seconds}`, period };
  };

  const { time, period } = formatTime(currentTime);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Enhanced contact handler
  const handleContactClick = () => {
    // You can choose one of these options or create a menu:
    // 1. Direct to Instagram
   // window.open('https://www.instagram.com/dashwebstudio/', '_blank');
    
  
    // window.location.href = 'tel:+96176536462';
    
    // 3. Open email client
     window.location.href = 'mailto:studiodashweb@gmail.com';
  };

  return (
    <>
      {/* Enhanced Time Section */}
      <section className="time">
        <div className="time__heading">
          <p>Time To Elevate<br />Your Digital Presence</p>
          <button 
            className="button" 
            onClick={handleContactClick}
            aria-label="Contact us via Instagram"
          >
            Contact Us
            <img 
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='7' y1='17' x2='17' y2='7'%3E%3C/line%3E%3Cpolyline points='7 7 17 7 17 17'%3E%3C/polyline%3E%3C/svg%3E" 
              alt="Arrow" 
              loading="lazy" 
            />
          </button>
        </div>
        <div className="time__timer">
          <p id="clock">
            {time}<span className="time__period">{period}</span>
          </p>
        </div>
      </section>

      {/* Enhanced Footer Section */}
      <footer className="footer">
        <section>
          <p className="footer__logo">DashWeb Studio</p>
          
          <div className="footer__content">
            {/* Newsletter Section */}
            <div className="footer__content-left">
            
                <button 
                  className="button button--secondary" 
                  onClick={openModal}
                >
                  Request Consultation
                </button>
              </div>
            
<div className="footer__content-right">
  {/* Column 1: Address */}
  <div className="footer__content-right__col-1">
    <div className="footer__content-right__col-1-address">
      <p className="title">Address</p>
      <div>
        <p className="desc">Tripoli</p>
        <p className="desc">Lebanon</p>
      </div>
    </div>
    <div className="footer__content-right__col-1-hours mt-4">
      <p className="title">Working Hours</p>
      <div>
        <p className="desc">Mon - Fri: 9:00 AM - 6:00 PM</p>
        <p className="desc">Sat: 10:00 AM - 3:00 PM</p>
        <p className="desc">Sun: Closed</p>
      </div>
    </div>
  </div>

  {/* Column 2: Collaboration and Contact */}
  <div className="footer__content-right__col-2">
    <div className="footer__content-right__col-2-colab">
      <p className="title">Collaboration</p>
      <div>
        <p className="desc">For project inquiries:</p>
        <a href="mailto:studiodashweb@gmail.com">studiodashweb@gmail.com</a>
      </div>
      <div>
        <p className="desc">Instagram:</p>
        <a href="https://www.instagram.com/dashwebstudio/" target="_blank" rel="noopener noreferrer">dashwebstudio</a>
      </div>
          </div>

    <div className="footer__content-right__col-2-support mt-6">
      <p className="title">Contact</p>
      <div>
        <div>
          <p className="desc">Phone:</p>
          <p>+961 76536462</p>
        </div>
        <div className="mt-2">
          <p className="desc">Support Email:</p>
          <a href="mailto:support@dashwebstudio.com">support@dashwebstudio.com</a>
        </div>
      </div>
    </div>

    <div className="footer__content-right__col-2-social mt-6">
      <p className="title">Follow Us</p>
      <div className="flex gap-4 mt-2">
        <a href="https://www.instagram.com/dashwebstudio/" target="_blank" rel="noopener noreferrer">Instagram</a>
      </div>
    </div>
  </div>
</div>
</div>
          <div className="footer__credentials">
            <p>©2025 DashWeb Studio</p>
            <p>All Rights Reserved</p>
            <a href="/privacy">Terms & Privacy</a>
          </div>
        </section>

        <Modal isOpen={isModalOpen} onClose={closeModal} showToast={showToast} />
      </footer>
    </>
  );
};

export default Footer;